import type { RefObject } from 'react';
import { useTranslate } from 'react-polyglot';

import { List } from '@genially/design-system';
import type { PlayerData } from '@genially/p2p-lib';

import { PlayersList } from '../../../../../../../../../../../../shared/application/components/PlayersList/PlayersList';
import { MoreParticipantsText, Wrapper } from './HandQueueTooltip.styled';

const VISIBLE_PLAYERS_LIMIT = 5;

interface HandQueueTooltipProps {
  players: PlayerData[];
  show: boolean;
  referenceElement: RefObject<Element> | null;
}

export const HandQueueTooltip = ({
  players,
  show,
  referenceElement,
}: HandQueueTooltipProps) => {
  const t = useTranslate();

  const visiblePlayers = players.slice(0, VISIBLE_PLAYERS_LIMIT);
  const extraCount = Math.max(0, players.length - VISIBLE_PLAYERS_LIMIT);

  const footerComponent =
    extraCount > 0 ? (
      <MoreParticipantsText>
        {t('__new.play.view.queueHandsUp', { number: extraCount })}
      </MoreParticipantsText>
    ) : undefined;

  return (
    <List
      show={show}
      referenceElement={referenceElement}
      placement={List.Placement.BOTTOM_START}
      distance={8}
      width="auto"
      preventScroll
      renderReferencePortalNode={document.body}
      variant={List.Variant.DARK}
      FooterComponent={footerComponent}
    >
      <Wrapper>
        <PlayersList
          players={visiblePlayers}
          forcedPlayerSize={PlayersList.PlayerSize.Small}
          direction={PlayersList.Direction.Row}
          playerWidthFull
          disableEnterAnimationOnLoad
        />
      </Wrapper>
    </List>
  );
};
